module.exports = __webpack_public_path__ + "6fa88ef09b5c434ba0706f257a70216d.pdf";